import { Component, OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';

import { Subscription } from 'rxjs';

import { languageService, languageSupport } from '@unpispas/upp-base';
import { viewService } from '@unpispas/upp-base';

import { dataService } from '@unpispas/upp-data';
import { PlaceView } from '@unpispas/upp-data';
import { QrCodeView } from '@unpispas/upp-data';
import { TicketView } from '@unpispas/upp-data';

import { ViewRenderer } from '@unpispas/upp-wdgt';

/** Overlay for session tickets that are ready and not yet notified. */
@Component({
    selector: 'upp-guest-ready',
    templateUrl: './upp-ready.html',
    styleUrls: ['./upp-ready.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef],
    }],
})
export class UppGuestReadyComponent extends languageSupport implements OnInit, OnDestroy {
    @Input() qrcode: QrCodeView | null = null;
    @Output() Close = new EventEmitter<void>();

    private _qrcode_subscription: Subscription | null = null;
    private _showticket: TicketView | null = null;

    constructor(
        private lang: languageService,
        private change: ViewRenderer,
        private data: dataService,
        public view: viewService,
    ) {
        super(lang, change.cdref);
    }

    get place(): PlaceView | null {
        return this.qrcode?.place ?? null;
    }

    get Tickets(): Array<TicketView> {
        return this.qrcode?.ReadyTickets ?? [];
    }

    get ShowTicket(): TicketView | null {
        return this._showticket;
    }

    ngOnInit(): void {
        this._BindRefresh();
        this._EmitIfEmpty();
    }

    ngOnDestroy(): void {
        if (this._qrcode_subscription) {
            this._qrcode_subscription.unsubscribe();
            this._qrcode_subscription = null;
        }
        super.OnDestroy();
    }

    OnShowTicket(ticket: TicketView | null): void {
        this._showticket = ticket;
        this.change.markForCheck();
    }

    TicketTrack(_index: number, ticket: TicketView): string | null {
        return ticket?._uuid || null;
    }

    async OnAccept(): Promise<void> {
        const tickets = this.qrcode?.ReadyTickets ?? [];
        if (tickets.length === 0) {
            this.Close.emit();
            return;
        }

        const transaction = this.data.transaction;
        for (const ticket of tickets) {
            ticket.IsNotifiedFlag = true;
            await transaction.push(ticket.object);
        }
        await transaction.flush();
        this.Close.emit();
        this.change.markForCheck();
    }

    private _BindRefresh(): void {
        if (this._qrcode_subscription) {
            this._qrcode_subscription.unsubscribe();
            this._qrcode_subscription = null;
        }

        if (this.qrcode) {
            this._qrcode_subscription = this.qrcode.OnRefresh.subscribe(() => {
                this._EmitIfEmpty();
                this.change.markForCheck();
            });
        }
    }

    private _EmitIfEmpty(): void {
        if ((this.qrcode?.ReadyTickets.length ?? 0) === 0) {
            this.Close.emit();
        }
    }
}
